import React, { Component } from "react";
import SettingsMenu from '../home/SettingsMenu';
import SettingsContent from '../home/SettingsContent';
import { connect } from "react-redux";
import { showMainErrorPop } from '../../actions/popups';


class SettingsPage extends Component {
  
  constructor(props) {
	super(props);
	this.settingsContent = React.createRef();
	this.state={
		chosenMenu: 'Personal Info'
    }
	
}
 
componentDidMount(){
	
}

updateStateFromChild=(state)=>{
	this.setState(state);
}

resetUserInfo=()=>{
	if ( this && this.settingsContent && this.settingsContent.current) 
		{ 
			this.settingsContent.current.resetUserInfo(); 
		}
}

  render() {
	 return (
		<div className="settings_page_content">
			<SettingsMenu chosenMenu={this.state.chosenMenu} resetUserInfo={this.resetUserInfo} updateStateFromChild={this.updateStateFromChild} state={this.state} ></SettingsMenu>
			<SettingsContent ref={this.settingsContent} chosenMenu={this.state.chosenMenu}></SettingsContent>
		</div>
    );
  }
}
export default connect(
  null,
  { 
	showMainErrorPop
  },
  null,
  {forwardRef: true}
)(SettingsPage);
